import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import waitForSaga from 'helpers/waitForSaga';
import MetaDataMarkup from 'components/MetaDataMarkup';
import { eventsPageLevelBaseProps, eventsPageViewProps } from 'helpers/pageViewProps/events';
import buildPageAnalytics from 'helpers/buildPageAnalytics';
import { gmConfig } from 'helpers/config';
import { EventPage } from 'views/Events';
import {
  getEvent,
  selectEventError,
  selectEventHasError,
  selectEventIsLoaded,
  selectEvent,
} from 'state/modules/events';
import { EVENTS_PAGE_NAME } from 'constants/pageNames';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';
import { evaluateFeatureFlag } from 'helpers/featureFlags';
import { FEATURE_FLAG_CREATE_ACCOUNT } from 'constants/FeatureFlags';

export const Events = (props) => {
  const { event, pageName, featureFlags } = props;

  const openGraphProps = {
    description: event.metaDescription,
    image: event.imageUrl,
    title: event.titleTag,
    type: 'website',
    url: `https://${gmConfig.domains.www}/events/${event.eventFileName}`,
  };

  return (
    <>
      <MetaDataMarkup
        title={event.titleTag}
        openGraphProps={openGraphProps}
        description={event.metaDescription}
      />
      <EventPage pageName={pageName} event={event} featureFlags={featureFlags} />
    </>
  );
};

const getErrorStatusCode = (store, eventSlug) => {
  const eventStatusIsError = selectEventHasError(store.getState(), eventSlug);

  if (eventStatusIsError) {
    const { statusCode } = selectEventError(store.getState(), eventSlug);

    if (statusCode) {
      return statusCode;
    }
  }

  return null;
};

export const handleServerSideProps = async (ctx) => {
  const {
    query: { eventSlug },
    store,
  } = ctx;
  // Fetch stuff
  const hasCreateAccount = await evaluateFeatureFlag(FEATURE_FLAG_CREATE_ACCOUNT, ctx);
  const eventLoaded = selectEventIsLoaded(store.getState(), eventSlug);
  if (!eventLoaded) await store.dispatch(getEvent(eventSlug));
  await waitForSaga(store);

  // Handle errors
  const errorCode = getErrorStatusCode(store, eventSlug);

  // getEventPage
  const eventPage = selectEvent(store.getState(), eventSlug);
  const pageAnalytics = buildPageAnalytics(
    EVENTS_PAGE_NAME,
    eventsPageViewProps(eventPage, { hasCreateAccount }),
    eventsPageLevelBaseProps(eventPage)
  );

  return {
    ...pageAnalytics,
    eventLoaded,
    eventSlug,
    errorCode,
    featureFlags: { hasCreateAccount },
  };
};

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, handleServerSideProps)
);

Events.propTypes = {
  event: PropTypes.shape({}).isRequired,
  pageName: PropTypes.string.isRequired,
  featureFlags: PropTypes.shape({}),
};

const mapStateToProps = (state, ownProps) => {
  if (ownProps.errorCode) return {};

  return {
    event: selectEvent(state, ownProps.eventSlug),
  };
};

export default connect(mapStateToProps)(Events);
